import { render, staticRenderFns } from "./CollocationSkus.vue?vue&type=template&id=7d3966da&scoped=true"
import script from "./CollocationSkus.vue?vue&type=script&lang=js"
export * from "./CollocationSkus.vue?vue&type=script&lang=js"
import style0 from "./CollocationSkus.vue?vue&type=style&index=0&id=7d3966da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3966da",
  null
  
)

export default component.exports